// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"12":"PostAuction","47":"PostAuctionRequest","51":"PostAnonymousAuctionController","456":"Header"}[chunkId] + "." + {"12":"f34bd","47":"f34bd","51":"f34bd","456":"f34bd"}[chunkId] + ".css";
};